import { z } from 'zod';
// A subscription sold after launch is concluded by accepting the terms
// at checkout rather than by signing anything, but presales agreed before launch do carry a signed contract.
export const partnerProductOrderDocumentTypeSchema = z.enum(['Contract', 'IntroForm', 'Unknown']);
export const PartnerProductOrderDocumentType = partnerProductOrderDocumentTypeSchema.enum;
export const subscriptionDocumentInputSchema = z.object({
    type: partnerProductOrderDocumentTypeSchema,
    // Uploads are addressed by uuid.
    fileIdentifier: z.uuid(),
    // The file already belongs to something else and has to be copied rather than moved, so the original keeps it.
    referenced: z.boolean().optional(),
});
export const subscriptionDocumentFileSchema = z.object({
    uuid: z.uuid(),
    displayName: z.string(),
    mimeType: z.string(),
    size: z.number().int().nullable(),
    url: z.string(),
    created: z.iso.datetime(),
});
export const subscriptionDocumentOutputSchema = z.object({
    uuid: z.uuid(),
    type: partnerProductOrderDocumentTypeSchema,
    file: subscriptionDocumentFileSchema,
});
